module.exports = __webpack_public_path__ + "static/media/hotel_spot.8a78cd7c.jpg";